// PayTableDialogContent.tsx

import symbolSwimmingTrunks from "../../../assets/static/images/symbols/v1/symbol-swimming-trunks.webp";
import symbolCoconutDrink from "../../../assets/static/images/symbols/v1/symbol-coconut-drink.webp";
import symbolSunglasses from "../../../assets/static/images/symbols/v1/symbol-sunglasses.webp";
import symbolBeachBall from "../../../assets/static/images/symbols/v1/symbol-beach-ball.webp";
import symbolStarfish from "../../../assets/static/images/symbols/v1/symbol-starfish.webp";
import symbolShell from "../../../assets/static/images/symbols/v1/symbol-shell.webp";
import symbolGoldenBeachCoins from "../../../assets/static/images/symbols/v1/symbol-golden-beach-coins.webp";
import symbolEnergyDrink from "../../../assets/static/images/symbols/v1/symbol-energy-drink.webp";
import { useSlice } from "@bridge-applications/provider-kit";
import { useTranslation } from "react-i18next";
import "./PayTableDialogContent.scss";

interface PayTableRow {
    id: string;
    icon?: string;
    beachCoinPrize?: string | readonly [minimum: string, maximum: string];
}

const PAYTABLE_ROWS: readonly PayTableRow[] = [
    { id: "noMatch" },
    {
        id: "twoLowSymbols",
        beachCoinPrize: ["125", "375"],
    },
    {
        id: "swimmingTrunks",
        icon: symbolSwimmingTrunks,
        beachCoinPrize: "500",
    },
    {
        id: "coconutDrinks",
        icon: symbolCoconutDrink,
        beachCoinPrize: "750",
    },
    {
        id: "sunglasses",
        icon: symbolSunglasses,
        beachCoinPrize: "1000",
    },
    {
        id: "beachBalls",
        icon: symbolBeachBall,
        beachCoinPrize: "1500",
    },
    {
        id: "starfish",
        icon: symbolStarfish,
        beachCoinPrize: "2500",
    },
    {
        id: "shells",
        icon: symbolShell,
        beachCoinPrize: "5000",
    },
    {
        id: "goldenBeachCoins",
        icon: symbolGoldenBeachCoins,
        beachCoinPrize: ["25000", "75000"],
    },
    {
        id: "energyDrinks",
        icon: symbolEnergyDrink,
    },
];

export default function PayTableDialogContent() {
    const { t, i18n } = useTranslation();
    const { state: slotMachineState } = useSlice("slotMachineSlice");
    const configVersion = slotMachineState.snapshot?.campaign.configVersion ?? "";
    const useRebalancedBeachCoinPrizes = ["v4", "v5", "v6", "v7"].includes(
        configVersion,
    );
    const rows = configVersion === "v7"
        ? PAYTABLE_ROWS.map((row): PayTableRow => row.id === "goldenBeachCoins"
            ? { ...row, beachCoinPrize: ["5000", "15000"] }
            : row)
        : PAYTABLE_ROWS;
    const numberFormatter = new Intl.NumberFormat(
        i18n.resolvedLanguage ?? i18n.language ?? "en",
        { maximumFractionDigits: 0 },
    );

    return (
        <div className="paytable-content">
            <div className="paytable-content__table-wrap">
                <table>
                    <thead>
                        <tr>
                            <th scope="col">
                                {t("payTable.headers.symbolCombination")}
                            </th>
                            <th scope="col">{t("payTable.headers.prize")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(({ id, icon, beachCoinPrize }) => (
                            <tr key={id}>
                                <td>
                                    <span className="paytable-content__combination">
                                        {icon && (
                                            <img
                                                src={icon}
                                                alt=""
                                                aria-hidden="true"
                                                draggable={false}
                                            />
                                        )}
                                        <span>
                                            {t(
                                                `payTable.rows.${id}.combination`,
                                            )}
                                        </span>
                                    </span>
                                </td>
                                <td>
                                    {beachCoinPrize === undefined ||
                                    !useRebalancedBeachCoinPrizes
                                        ? t(`payTable.rows.${id}.prize`)
                                        : t("payTable.beachCoinPrize", {
                                              amount:
                                                  typeof beachCoinPrize ===
                                                  "string"
                                                      ? numberFormatter.format(
                                                            BigInt(beachCoinPrize),
                                                        )
                                                      : `${numberFormatter.format(
                                                            BigInt(beachCoinPrize[0]),
                                                        )}–${numberFormatter.format(
                                                            BigInt(beachCoinPrize[1]),
                                                        )}`,
                                          })}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
